/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import SubMenuTab from 'DesignSystem/SubMenuTab/index'
import TysiaIconDentalMonitoring from 'DesignSystem/Svgs/TysiaIconDentalMonitoring/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/Tabs/DentalMonitoring/Content"
  
}) {
let tabTabValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'tab',
})
let constantData = 'dental-monitoring'
let aggregateData = fromAggregate.equals(tabTabValueData, constantData)
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<SubMenuTab
  viewPath={`${viewPath}/SubMenuTab`}
 text="DM"
 onClick={onClick}
 title="Dental monitoring"
 size="normal"
 color={dtColorsNeutral900}
 data="tab.tab"
 data="'dental-monitoring'"
 aggregate="/Data/aggregate.js equals"
 isSelected={aggregateData}
>
{childProps => (
<TysiaIconDentalMonitoring
{...childProps}
  viewPath={`${viewPath}/TysiaIconDentalMonitoring`}
 height={13}
 width={13}
/>
)}
</SubMenuTab>
{children}
</React.Fragment>)
}